import React from 'react';
import { RequestProvider, withFlagsConsumer } from '@shootsta/common-react';
import IdentityLoginComponent from '../components/IdentityLogin';
import { getOrgNameFromAliasApi } from '../api';

const IdentityLogin = ({ flags }: any) => (
  <RequestProvider
    requests={{
      getOrganisationNameFromAlias: getOrgNameFromAliasApi()
    }}
  >
    {({ getOrganisationNameFromAlias }) => (
      <IdentityLoginComponent
        getOrganisationNameFromAlias={getOrganisationNameFromAlias} flags={flags}
      />
    )}
  </RequestProvider>
);

export default withFlagsConsumer(IdentityLogin);
